const dev = false;

let socketServer = "";
let peerServer = "";
let peerPort = "";
let peerPath = "";
let https = "";

if (dev) {
  socketServer = "http://localhost:7000";
  peerServer = "localhost";
  peerPort = 9000;
  peerPath = "/";
  https = false;
} else {
  socketServer = "https://server-chat-online.gorillabyte.com.br";
  peerServer = "chatonline.gorillabyte.com.br";
  peerPort = 443;
  peerPath = "/peerjs";
  https = true;
}

export default {
  socketServer: socketServer,
  peerServer: peerServer,
  peerPort: peerPort,
  peerPath: peerPath,
  https: https,
};
